function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M14.815 3.806l-2.44 2.442a.438.438 0 00.307.752h1.565A5.253 5.253 0 019 12.25a5.09 5.09 0 01-1.968-.385c-.314-.131-.673-.035-.91.201a.877.877 0 00.298 1.435C7.216 13.825 8.09 14 9 14a6.996 6.996 0 006.996-7h1.565a.433.433 0 00.306-.744l-2.44-2.441a.43.43 0 00-.612-.009zM3.753 7A5.253 5.253 0 019 1.75c.69 0 1.364.131 1.968.385.314.131.673.035.91-.201A.877.877 0 0011.58.499 6.842 6.842 0 009 0a6.996 6.996 0 00-6.996 7H.439a.433.433 0 00-.306.744l2.44 2.441a.433.433 0 00.62 0l2.44-2.441A.437.437 0 005.318 7H3.753z",
  fill: "#148CFC",
  fillRule: "evenodd"
});

var SvgUpdate = function SvgUpdate(props) {
  return React.createElement("svg", _extends({
    width: 18,
    height: 14
  }, props), _ref);
};

export default SvgUpdate;